import PropTypes from "prop-types";

const FavouriteMapPin = ({ width = 37, height = 47 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 42 54"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_f_7050_7779)">
      <ellipse
        cx="21"
        cy="49.5"
        rx="7"
        ry="2.5"
        fill="black"
        fillOpacity="0.2"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21 0C32.598 0 42 9.40202 42 21C42 29.8926 36.4727 37.4942 28.6663 40.5567L22.1961 49.4007C22.0612 49.5858 21.8821 49.7369 21.6739 49.8412C21.4657 49.9455 21.2346 50 21 50C20.7654 50 20.5343 49.9455 20.3261 49.8412C20.1179 49.7369 19.9388 49.5858 19.8039 49.4007L13.3337 40.5567C5.52726 37.4941 0 29.8926 0 21C0 9.40202 9.40202 0 21 0Z"
      fill="#FF2600"
    />
    <g clipPath="url(#clip0_7050_7779)">
      <foreignObject x="-18" y="-16.1" width="78.0002" height="76.6365">
        <div
          xmlns="http://www.w3.org/1999/xhtml"
          style={{
            backdropFilter: "blur(15px)",
            clipPath: "url(#bgblur_1_7050_7779_clip_path)",
            height: "100%",
            width: "100%"
          }}
        />
      </foreignObject>
      <g filter="url(#filter2_d_7050_7779)" data-figma-bg-blur-radius="30">
        <path
          d="M21.0009 15.2761C23.115 13.378 26.382 13.441 28.4187 15.4813C30.4545 17.5225 30.5247 20.7733 28.6311 22.8937L20.9991 30.5365L13.3689 22.8937C11.4753 20.7733 11.5464 17.5171 13.5813 15.4813C15.6198 13.4437 18.8805 13.3753 21.0009 15.2761Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_f_7050_7779"
        x="12"
        y="45"
        width="18"
        height="9"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="1"
          result="effect1_foregroundBlur_7050_7779"
        />
      </filter>
      <filter
        id="filter2_d_7050_7779"
        x="-18"
        y="-16.1"
        width="78.0002"
        height="76.6365"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_7050_7779"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_7050_7779"
          result="shape"
        />
      </filter>
      <clipPath id="bgblur_1_7050_7779_clip_path">
        <path
          transform="translate(18 16.1)"
          d="M21.0009 15.2761C23.115 13.378 26.382 13.441 28.4187 15.4813C30.4545 17.5225 30.5247 20.7733 28.6311 22.8937L20.9991 30.5365L13.3689 22.8937C11.4753 20.7733 11.5464 17.5171 13.5813 15.4813C15.6198 13.4437 18.8805 13.3753 21.0009 15.2761Z"
        />
      </clipPath>
      <clipPath id="clip0_7050_7779">
        <rect width="24" height="24" fill="white" transform="translate(9 10)" />
      </clipPath>
    </defs>
  </svg>
);

const { number } = PropTypes;

FavouriteMapPin.propTypes = {
  width: number,
  height: number
};

export default FavouriteMapPin;
